<template>
<section class="search_title">
  <div class="content_wrap">
        <h2><span v-if="this.PrefName">{{this.PrefName}}エリア</span><span v-if="this.inputKeyword">キーワード『{{this.inputKeyword}}』の</span><span v-if="this.selectedType">{{this.selectedType}}</span>一覧</h2>
  </div><!-- /.content_wrap -->
</section><!-- /.search_box -->
</template>

<script>
export default {
    props: {
      pref: String,
      type: String,
      keyword: String
    },
    data() {
      return {
        PrefName: null,
        selectedType: null,
        inputKeyword: null,
      };
    },
    created() {
      var self = this;
      if(self.pref){
        var target = this.prefs.filter(function(item, index){
          if (item.id == Number(self.pref)) return true;
        });
        this.PrefName = target[0].name;
      }
      if(self.type) {
        if(self.type == 'salon') {
          this.selectedType = '認定ネイルサロン';
        } else if(self.type == 'school'){
          this.selectedType = '認定校';
        } else if(self.type == 'corporate'){
          this.selectedType = 'ネイル関連企業';
        }
      }
      if(self.keyword){
        this.inputKeyword = self.keyword;
      }
    },
    updated() {

    }
}
</script>